import { TourType } from "./TourType";
import { CreateOrderRequestShipment } from "./CreateOrderRequestShipment";
import { BookDirectOrder } from "../../features/bookDirect/model/BookDirectOrder";
import { BookMultiOrder } from "../../features/bookMulti/model/BookMultiOrder";

export class CreateOrderRequest {
  order: {
    tourType: TourType;
    shipments: CreateOrderRequestShipment[];
    internalReference?: string;
    comment?: string;
  };

  constructor(
    tourType: TourType,
    shipments: CreateOrderRequestShipment[],
    internalReference?: string,
    comment?: string
  ) {
    this.order = {
      tourType: tourType,
      shipments: shipments,
      internalReference: internalReference,
      comment: comment
    };
  }

  static requestForDirectOrder = (
    order: BookDirectOrder
  ): CreateOrderRequest => {
    return new CreateOrderRequest(
      TourType.Direct,
      [CreateOrderRequestShipment.shipmentForDirectOrder(order)],
      order.internalReference,
      order.comment
    );
  };

  static requestForMultiOrder = (order: BookMultiOrder): CreateOrderRequest => {
    const shipments = order.multiPoints.map((mp, i) => {
      const startAddress =
        order.type! === TourType.Distribution
          ? order.singlePoint.address.id!
          : mp.address.id!;
      const endAddress =
        order.type! === TourType.Distribution
          ? mp.address.id!
          : order.singlePoint.address.id!;
      const startWindow =
        order.type! === TourType.Distribution
          ? order.singlePoint.timewindow
          : mp.timewindow;
      const endWindow =
        order.type! === TourType.Distribution
          ? mp.timewindow
          : order.singlePoint.timewindow;
      const loads = mp.loads.map(l => {
        // bad hack to send FE custom label to backend
        if (
          l.label === "nicht palettiert, eigenes Maß" ||
          l.label === "palettiert, eigenes Maß"
        ) {
          return {
            ...l,
            label: `${l.customLabel ? l.customLabel + ", " : ""}${l.label}`
          };
        }
        return l;
      });

      if (!order.date) throw new Error("validation failed: date missing");

      return new CreateOrderRequestShipment(
        startAddress,
        endAddress,
        order.date,
        startWindow,
        endWindow,
        loads,
        order.extras,
        order.type! === TourType.Distribution
          ? order.singlePoint.comment
          : mp.comment,
        order.type! === TourType.Distribution
          ? mp.comment
          : order.singlePoint.comment
      );
    });
    return new CreateOrderRequest(
      // technically the order is direct when we have only a -> b so we have to catch that here
      shipments.length === 1 ? TourType.Direct : order.type!,
      shipments,
      order.internalReference,
      order.comment
    );
  };
}
